import { module } from 'stereomodularjs';
import Vue from 'vue';
import { compileToFunctions } from 'vue-template-compiler';
import { Loader } from "@googlemaps/js-api-loader"

export default class extends module {
    constructor(m) {
        super(m);
    }

    async init() {
        const template = this.el.nextElementSibling;
        //Json decode data-address
        let address = JSON.parse(this.el.dataset.address);
        let key = this.el.dataset.key;
        const myLatLng = {
            lat: address.lat,
            lng : address.lng,
        };
        template.remove();
        const loader = new Loader({
          apiKey: key,
          version: "weekly",
        });
        await loader.load();
        this.initVUE(template, myLatLng);
    }

    initVUE(template, myLatLng){
        Vue.config.devtools = true;
        Vue.config.productionTip = false;
        //Cast template as string
        template = template.innerHTML;
        const res = compileToFunctions(template);
        const app = new Vue({
            el: this.el,
            ...res,
            data: {
                maps: [],
                myLatLng: myLatLng,
                styles: [
                    {
                      "featureType": "administrative.land_parcel",
                      "elementType": "labels",
                      "stylers": [
                        {
                          "visibility": "on"
                        }
                      ]
                    },
                    {
                      "featureType": "landscape",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#9cbeaf"
                        }
                      ]
                    },
                    {
                      "featureType": "landscape",
                      "elementType": "geometry.fill",
                      "stylers": [
                        {
                          "visibility": "on"
                        }
                      ]
                    },
                    {
                      "featureType": "landscape",
                      "elementType": "labels",
                      "stylers": [
                        {
                          "visibility": "on"
                        }
                      ]
                    },
                    {
                      "featureType": "landscape",
                      "elementType": "labels.text",
                      "stylers": [
                        {
                          "color": "#ffffff"
                        },
                        {
                          "weight": "0.01"
                        }
                      ]
                    },
                    {
                      "featureType": "landscape",
                      "elementType": "labels.text.stroke",
                      "stylers": [
                        {
                          "color": "#ffffff"
                        }
                      ]
                    },
                    {
                      "featureType": "landscape.natural",
                      "elementType": "labels.text",
                      "stylers": [
                        {
                          "visibility": "on"
                        }
                      ]
                    },
                    {
                      "featureType": "poi",
                      "elementType": "labels.text",
                      "stylers": [
                        {
                          "color": "#ffffff"
                        },
                        {
                          "visibility": "on"
                        },
                        {
                          "weight": "0.01"
                        }
                      ]
                    },
                    {
                      "featureType": "poi",
                      "elementType": "labels.text.stroke",
                      "stylers": [
                        {
                          "color": "#ffffff"
                        }
                      ]
                    },
                    {
                      "featureType": "poi",
                      "elementType": "labels.icon",
                      "stylers": [
                        {
                          "visibility": "on"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.attraction",
                      "elementType": "all",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.business",
                      "elementType": "all",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#ffcf70"
                        },
                        {
                          "visibility": "on"
                        }
                      ]
                    },
                    {
                      "featureType": "road.arterial",
                      "elementType": "all",
                      "stylers": [
                        {
                          "visibility": "on"
                        }
                      ]
                    },
                    {
                      "featureType": "road.arterial",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#9cbeaf"
                        }
                      ]
                    },
                    {
                      "featureType": "road.arterial",
                      "elementType": "labels.text",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "road.local",
                      "elementType": "all",
                      "stylers": [
                        {
                          "visibility": "on"
                        }
                      ]
                    },
                    {
                      "featureType": "road.local",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#043a36"
                        },
                        {
                          "visibility": "on"
                        }
                      ]
                    },
                    {
                      "featureType": "road.local",
                      "elementType": "geometry.stroke",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "road.local",
                      "elementType": "labels.text",
                      "stylers": [
                        {
                          "color": "#4d80d6"
                        },
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "water",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#93b8f5"
                        }
                      ]
                    },
                    {
                      "featureType": "water",
                      "elementType": "geometry.fill",
                      "stylers": [
                        {
                          "color": "#4d80d6"
                        }
                      ]
                    }
                  ],
            },
            methods: {
                initMaps() {
                    var map = new google.maps.Map(this.$el.querySelector('#map'), {
                        center: this.myLatLng,
                        zoom: 15.3,
                        styles: this.styles,
                        disableDefaultUI: true,
                      });

                      var marker = new google.maps.Marker({
                        position: this.myLatLng,
                        map: map,
                        title: 'Îles Saint Quentin',
                        icon: {
                            url: '/app/themes/baserock/assets/img/map_icon_white.png',
                            //scaledSize: new google.maps.Size(38, 58),
                        }
                      });
                }
            },
            mounted() {
                this.initMaps();
            }
        });
    }

    destroy() {
        // Destroy your module here
        app.$destroy();
    }
}